import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Warranty from "./warranty";
import Shoppingmall from "./shoppingmall";
import Consult from "./consult";
import Experience from "./experience";
import SeoMeta from "components/app/SEOMeta";
import Questions from "components/app/questions";

function Bar(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const feature01Text = isMobile
    ? "최대 10명이 참여할 수 있는 회의실, 연구실 그룹 또는 허들룸에 우수한 품질의 오디오 및 비디오를 제공하는데 적합합니다."
    : "최대 10명이 참여할 수 있는 회의실, 연구실 그룹 또는 허들룸에\n우수한 품질의 오디오 및 비디오를 제공하는데 적합합니다.";
  const feature02Text = isMobile
    ? "Neat Bar는 한 대 또는 두 대의 모니터를 위 or 아래에 장착할 수 있으며, Neat Bar를 컨트롤하는 Neat Pad와 함께 제공됩니다. 누구나 쉽게 설정하고 사용할 수 있습니다."
    : "Neat Bar는 한 대 또는 두 대의 모니터를 위 or 아래에 장착할 수 있으며,\nNeat Bar를 컨트롤하는 Neat Pad와 함께 제공됩니다.\n누구나 쉽게 설정하고 사용할 수 있습니다.";
  const feature03Text = isMobile
    ? "Neat Bar가 작은 화면이나 모니터 위에 맞도록 맞춤 제작된 연결장치가 있습니다. 접착테이프로 화면이나 모니터 뒷면에 부착되며 모든 디스플레이에 적합합니다."
    : "Neat Bar가 작은 화면이나 모니터 위에 맞도록 맞춤 제작된 연결장치가 있습니다.\n접착테이프로 화면이나 모니터 뒷면에 부착되며 모든 디스플레이에 적합합니다.";
  return (
    <>
      <SeoMeta
        title="neat.bar, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - neat. bar"
        keywords="리브테크놀로지, 리브, riv, riv Technology, neat, bar, neat bar, 화상회의"
      />
      <div className={style.device_title_wrap}>
        <div className={style.device_subtitle}>
          <span>All-in-One, AI</span> 화상회의 디바이스
        </div>
        <div className={style.device_title}>
          <img
            className={style.small_title}
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/title_neat_bar${isMobile ? "_m" : ""}.webp`
            }
            alt="bar"
          />
        </div>
      </div>
      <div className={style.device_text} style={{ display: "block" }}>
        <span>중소형 회의실 및 교육장을 위한</span>
        {isMobile ? (
          <>
            <br />
          </>
        ) : (
          " "
        )}
        최적의 화상회의 장비
      </div>

      <div className={style.device_img_list}>
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/bar_1${
            isMobile ? "_m" : ""
          }.webp`}
          alt="bar"
        />
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/bar_2${
            isMobile ? "_m" : ""
          }.webp`}
          alt="bar"
        />
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/bar_3${
            isMobile ? "_m" : ""
          }.webp`}
          alt="bar"
        />
      </div>

      <div className={style.device_description_wrap}>
        <div className={style.device_description_img_box}>
          <img
            src={`${
              process.env.REACT_APP_CLIENT_URL
            }img/device/neat/bar_device${isMobile ? "_m" : ""}.webp`}
            alt="bar"
          />
          <div className={style.device_description_text_box}>
            Neat Pad (컨트롤러) 포함
          </div>
        </div>
        <div className={style.device_description_list_wrap}>
          <div className={style.device_description_list}>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/device${isMobile ? "_m" : ""}.webp`
                  }
                  alt="device"
                />
              </div>
              <div className={style.device_description_text}>
                <span>최대 10명이</span> 참여할 수 있는 회의의 고성능 영상회의
                장비
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/dual_screen${isMobile ? "_m" : ""}.webp`
                  }
                  alt="dual_screen"
                />
              </div>
              <div className={style.device_description_text}>
                <span>듀얼 스크린</span> 지원 · <span>위/아래</span> 장착 가능
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/sync${isMobile ? "_m" : ""}.webp`
                  }
                  alt="sync"
                />
              </div>
              <div className={style.device_description_text}>
                회의실 입장 시, <span>자동으로</span> 회의실 모니터{" "}
                <span>활성화 & 체크인</span>
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/setting${isMobile ? "_m" : ""}.webp`
                  }
                  alt="setting"
                />
              </div>
              <div className={style.device_description_text}>
                <span>누구나</span> 쉽게 설치하고 간편한 설정 및 작동 가능
              </div>
            </div>
          </div>

          <div className={style.device_support_platform_wrap}>
            <div className={style.device_support_platform_title_wrap}>
              <div className={style.device_support_platform_horizon}></div>
              <div className={style.device_support_platform_title}>
                지원 플랫폼
              </div>
            </div>
            <div className={style.device_support_platform_list}>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_zoom_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/zoom_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="zoom"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>ZOOM</span>
                </div>
              </div>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_teams_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/teams_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="teams"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>Microsoft Teams</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_vertical_line_wrap}>
        <div className={style.device_vertical_line}></div>
      </div>

      <div className={style.device_features_wrap}>
        <div className={style.device_features_title}>
          Neat Bar <span>특장점</span>
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_bar_1${isMobile ? "_m" : ""}.webp`
                }
                alt="feature1"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"1".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  강의실 및 허들룸
                </div>
              </div>
              <div className={style.device_features_text}>{feature01Text}</div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_bar_2${isMobile ? "_m" : ""}.webp`
                }
                alt="feature2"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"2".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  컨트롤러 제공
                </div>
              </div>
              <div className={style.device_features_text}>{feature02Text}</div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_bar_3${isMobile ? "_m" : ""}.webp`
                }
                alt="feature3"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"3".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  간편 설치 맞춤형 연결장치
                </div>
              </div>
              <div className={style.device_features_text}>{feature03Text}</div>
            </div>
          </div>
        </div>
      </div>

      <Experience />

      <div className={style.device_spec_wrap}>
        <div className={style.device_spec_title}>제품 사양</div>

        <div className={style.device_size_img_wrap}>
          <div className={style.device_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/spec_bar_1${isMobile ? "_m" : ""}.png`
              }
              alt="spec1"
            />
          </div>
          <div className={style.device_spec_img_wrap}>
            <div
              className={style.device_spec_img_box}
              style={{ backgroundColor: "#e8e8e8" }}
            >
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_bar_2${isMobile ? "_m" : ""}.png`
                }
                alt="spec2"
              />
            </div>
            <div
              className={style.device_spec_img_box}
              style={{ backgroundColor: "#e8e8e8" }}
            >
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_bar_3${isMobile ? "_m" : ""}.png`
                }
                alt="spec3"
              />
            </div>
          </div>
        </div>

        <div className={style.device_spec_text_wrap}>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "67px" }}
            >
              <div className={style.device_spec_text_label}>일반</div>
              <div className={style.device_spec_text}>
                <span>카메라 및 시스템 LED</span>
                <span>가속도계</span>
                <span>듀얼 스크린 지원</span>
                <span>보안 잠금 슬롯(Kensington 호환)</span>
                <span>보안 부팅</span>
                <span>Zoom Rooms / Microsoft Teams Room</span>
                <span>온도, 습도, CO2 및 VOC용 센서</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "40px" }}
            >
              <div className={style.device_spec_text_label}>오디오</div>
              <div className={style.device_spec_text}>
                <span>풀레인지 스피커</span>
                <span>진동방지 드라이버</span>
                <span>광각 트위터</span>
                <span>센서 마이크 3개</span>
                <span>빔포밍 마이크 5개</span>
                <span>하드웨어 가속 오디오 프로세서</span>
                <span>빔포밍</span>
                <span>에코 제거</span>
                <span>자동 게인 컨트롤</span>
              </div>
            </div>
          </div>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "145px" }}
            >
              <div className={style.device_spec_text_label}>비디오</div>
              <div className={style.device_spec_text}>
                <span>4x 디지털 줌(최대 8x 디지털 줌)</span>
                <span>12MP 캡처 해상도</span>
                <span>120도 수평 시야각</span>
                <span>자동 인물 프레이밍</span>
                <span>하드웨어 가속 비디오 인코딩 및 디코딩</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "45px" }}
            >
              <div className={style.device_spec_text_label}>
                네트워크 & 포트
              </div>
              <div className={style.device_spec_text}>
                <span>Wi-Fi</span>
                <span>Bluetooth (MS Teams Proximity Join 기능)</span>
                <span>AC전원 (내장)</span>
                <span>이더넷 포트</span>
                <span>2 x HDMI 출력 </span>
                <span>HDMI 입력 (화면공유)</span>
                <span>USB-C : BYOD모드 또는 터치스크린 연결</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "87px" }}
            >
              <div className={style.device_spec_text_label}>크기 및 무게</div>
              <div className={style.device_spec_text}>
                <span>너비: 556mm(21.9인치)</span>
                <span>높이: 76mm(3인치)</span>
                <span>깊이: 76mm(3인치)</span>
                <span>무게: 1.7kg(3.75파운드)</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_icon_wrap}
          style={{
            backgroundImage: `url('${
              process.env.REACT_APP_CLIENT_URL
            }img/device/neat/spec_bar_bg${isMobile ? "_m" : ""}.webp')`,
          }}
        >
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>120°</div>
            <div className={style.device_spec_icon_label}>광각 카메라</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>12 MP</div>
            <div className={style.device_spec_icon_label}>캡처 해상도</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>4x</div>
            <div className={style.device_spec_icon_label}>
              디지털 줌(8배 옵션)
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                class={style.micArray_icon}
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/mic_array${isMobile ? "_m" : ""}.webp`}
                alt="mic"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              5개 마이크 어레이
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                class={style.vibration_icon}
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/vibration${isMobile ? "_m" : ""}.webp`}
                alt="vibration"
              />
            </div>
            <div className={style.device_spec_icon_label}>진동 상쇄 설계</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                class={style.wideAngle_icon}
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/wide_angle${isMobile ? "_m" : ""}.webp`}
                alt="wideangle"
              />
            </div>
            <div className={style.device_spec_icon_label}>광각 트위터</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                class={style.dualScreen_icon}
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/dual_screen_white${isMobile ? "_m" : ""}.webp`}
                alt="dualscreen"
              />
            </div>
            <div className={style.device_spec_icon_label}>듀얼 스크린 지원</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                class={style.wifi_icon}
                src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/wifi${
                  isMobile ? "_m" : ""
                }.webp`}
                alt="wifi"
              />
            </div>
            <div className={style.device_spec_icon_label}>와이파이</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>Sensors</div>
            <div className={style.device_spec_icon_label}>빛·센서·공기 질</div>
          </div>
        </div>

        <Warranty />
      </div>

      <Shoppingmall type="bar" isMobile={isMobile} />
      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default Bar;
